export const COHORT_ABI = [
  // Name Registry
  {
    type: 'function',
    name: 'names',
    stateMutability: 'view',
    inputs: [{ name: 'hash', type: 'bytes32' }],
    outputs: [{ name: '', type: 'string' }]
  },
  {
    type: 'function',
    name: 'registerName',
    stateMutability: 'nonpayable',
    inputs: [{ name: 'name', type: 'string' }],
    outputs: []
  },
  {
    type: 'function',
    name: 'registerNames',
    stateMutability: 'nonpayable',
    inputs: [{ name: 'names', type: 'string[]' }],
    outputs: []
  },
  // Core Functions
  {
    type: 'function',
    name: 'recordSession',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'participantIds', type: 'bytes32[]' },
      { name: 'importance', type: 'uint8' },
      { name: 'points', type: 'uint256[]' },
      { name: 'v', type: 'uint8' },
      { name: 'r', type: 'bytes32' },
      { name: 's', type: 'bytes32' }
    ],
    outputs: []
  },
  {
    type: 'function',
    name: 'requestSigner',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'requester', type: 'address' }
    ],
    outputs: []
  },
  {
    type: 'function',
    name: 'addSigner',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'newSigner', type: 'address' },
      { name: 'v', type: 'uint8' },
      { name: 'r', type: 'bytes32' },
      { name: 's', type: 'bytes32' }
    ],
    outputs: []
  },
  {
    type: 'function',
    name: 'removeSigner',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'signerToRemove', type: 'address' },
      { name: 'v', type: 'uint8' },
      { name: 'r', type: 'bytes32' },
      { name: 's', type: 'bytes32' }
    ],
    outputs: []
  },
  {
    type: 'function',
    name: 'finalize',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'v', type: 'uint8' },
      { name: 'r', type: 'bytes32' },
      { name: 's', type: 'bytes32' }
    ],
    outputs: []
  },
  {
    type: 'function',
    name: 'invalidateSession',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'sessionId', type: 'uint256' },
      { name: 'v', type: 'uint8' },
      { name: 'r', type: 'bytes32' },
      { name: 's', type: 'bytes32' }
    ],
    outputs: []
  },
  // View Functions
  {
    type: 'function',
    name: 'cohortExists',
    stateMutability: 'view',
    inputs: [{ name: 'cohortId', type: 'bytes32' }],
    outputs: [{ name: '', type: 'bool' }]
  },
  {
    type: 'function',
    name: 'getSigners',
    stateMutability: 'view',
    inputs: [{ name: 'cohortId', type: 'bytes32' }],
    outputs: [{ name: '', type: 'address[]' }]
  },
  {
    type: 'function',
    name: 'getParticipantIds',
    stateMutability: 'view',
    inputs: [{ name: 'cohortId', type: 'bytes32' }],
    outputs: [{ name: '', type: 'bytes32[]' }]
  },
  {
    type: 'function',
    name: 'sessionCount',
    stateMutability: 'view',
    inputs: [{ name: 'cohortId', type: 'bytes32' }],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'signerNonce',
    stateMutability: 'view',
    inputs: [{ name: 'cohortId', type: 'bytes32' }],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'sessionImportance',
    stateMutability: 'view',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'sessionId', type: 'uint256' }
    ],
    outputs: [{ name: '', type: 'uint8' }]
  },
  {
    type: 'function',
    name: 'sessionPoints',
    stateMutability: 'view',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'sessionId', type: 'uint256' },
      { name: 'participantId', type: 'bytes32' }
    ],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'sessionInvalidated',
    stateMutability: 'view',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'sessionId', type: 'uint256' }
    ],
    outputs: [{ name: '', type: 'bool' }]
  },
  {
    type: 'function',
    name: 'sessionTimestamp',
    stateMutability: 'view',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'sessionId', type: 'uint256' }
    ],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'finalized',
    stateMutability: 'view',
    inputs: [{ name: 'cohortId', type: 'bytes32' }],
    outputs: [{ name: '', type: 'bool' }]
  },
  {
    type: 'function',
    name: 'getShare',
    stateMutability: 'view',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'participantId', type: 'bytes32' },
      { name: 'multipliers', type: 'uint256[6]' }
    ],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'getDistribution',
    stateMutability: 'view',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'multipliers', type: 'uint256[6]' }
    ],
    outputs: [
      { name: 'shares', type: 'uint256[]' },
      { name: 'total', type: 'uint256' }
    ]
  },
  {
    type: 'function',
    name: 'distribute',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'cohortId', type: 'bytes32' },
      { name: 'token', type: 'address' },
      { name: 'amount', type: 'uint256' },
      { name: 'addresses', type: 'address[]' },
      { name: 'multipliers', type: 'uint256[6]' }
    ],
    outputs: []
  },
  // Events
  {
    type: 'event',
    name: 'NameRegistered',
    inputs: [
      { name: 'hash', type: 'bytes32', indexed: true },
      { name: 'name', type: 'string', indexed: false }
    ]
  },
  {
    type: 'event',
    name: 'CohortCreated',
    inputs: [
      { name: 'cohortId', type: 'bytes32', indexed: true },
      { name: 'signer', type: 'address', indexed: false }
    ]
  },
  {
    type: 'event',
    name: 'SignerAdded',
    inputs: [
      { name: 'cohortId', type: 'bytes32', indexed: true },
      { name: 'signer', type: 'address', indexed: false }
    ]
  },
  {
    type: 'event',
    name: 'SignerRemoved',
    inputs: [
      { name: 'cohortId', type: 'bytes32', indexed: true },
      { name: 'signer', type: 'address', indexed: false }
    ]
  },
  {
    type: 'event',
    name: 'SignerRequested',
    inputs: [
      { name: 'cohortId', type: 'bytes32', indexed: true },
      { name: 'requester', type: 'address', indexed: true }
    ]
  },
  {
    type: 'event',
    name: 'SessionRecorded',
    inputs: [
      { name: 'cohortId', type: 'bytes32', indexed: true },
      { name: 'sessionId', type: 'uint256', indexed: true },
      { name: 'importance', type: 'uint8', indexed: false }
    ]
  },
  {
    type: 'event',
    name: 'SessionInvalidated',
    inputs: [
      { name: 'cohortId', type: 'bytes32', indexed: true },
      { name: 'sessionId', type: 'uint256', indexed: true }
    ]
  },
  {
    type: 'event',
    name: 'Finalized',
    inputs: [{ name: 'cohortId', type: 'bytes32', indexed: true }]
  },
  {
    type: 'event',
    name: 'Distributed',
    inputs: [
      { name: 'cohortId', type: 'bytes32', indexed: true },
      { name: 'token', type: 'address', indexed: true },
      { name: 'amount', type: 'uint256', indexed: false }
    ]
  }
] as const;

// ERC20 ABI for token approval
export const ERC20_ABI = [
  {
    type: 'function',
    name: 'approve',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' }
    ],
    outputs: [{ name: '', type: 'bool' }]
  },
  {
    type: 'function',
    name: 'allowance',
    stateMutability: 'view',
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' }
    ],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'balanceOf',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ name: '', type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'decimals',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'uint8' }]
  },
  {
    type: 'function',
    name: 'symbol',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ name: '', type: 'string' }]
  }
] as const;
